import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SolicitudesService } from '@services/ofertas-laborales/solicitudes.service';

export interface HistorialDifItem {
    _id: string;
    nro: number;
    fecha: string;
    numberState: number;
    estado: string;
    actividad: string;
    sede: string;
}

export type GrupoHistorialDif = 'aprobadas' | 'anuladas';

/**
 * Historial del dif de un beneficiario: las solicitudes que forman el `+N / -N`
 * de la columna `Dif.` de la bandeja.
 *
 * Modal de pantalla (no el popup chico): mismo esqueleto `ds-*` que el detalle
 * de Gecros, con dos tarjetas — aprobadas y anuladas — y el ojo de cada fila
 * para abrir la solicitud.
 */
@Component({
    selector: 'app-modal-historial-dif',
    templateUrl: './modal-historial-dif.component.html',
    styleUrls: ['./modal-historial-dif.component.scss'],
})
export class ModalHistorialDifComponent implements OnInit {
    cargando = true;
    historial: {
        aprobadas: HistorialDifItem[];
        anuladas: HistorialDifItem[];
    } | null = null;

    readonly grupos = [
        {
            key: 'aprobadas' as GrupoHistorialDif,
            titulo: 'Aprobadas',
            icono: 'check_circle',
            chip: 'aprobado',
        },
        {
            key: 'anuladas' as GrupoHistorialDif,
            titulo: 'Anuladas',
            icono: 'cancel',
            chip: 'anulado',
        },
    ];

    constructor(
        public dialogRef: MatDialogRef<ModalHistorialDifComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { beneficiarioId: string; nombre: string },
        private solicitudesService: SolicitudesService,
    ) {}

    ngOnInit(): void {
        void this.cargar();
    }

    private async cargar(): Promise<void> {
        try {
            this.historial = await this.solicitudesService.historialDiferencial(
                this.data.beneficiarioId,
            );
        } catch (error) {
            console.error('Error al traer el historial del dif:', error);
            this.historial = { aprobadas: [], anuladas: [] };
        } finally {
            this.cargando = false;
        }
    }

    /** Filas del grupo; devuelve [] mientras carga para no romper el template. */
    items(grupo: GrupoHistorialDif): HistorialDifItem[] {
        return this.historial ? this.historial[grupo] : [];
    }

    /**
     * El ojo de una fila cierra la modal y devuelve el id: la bandeja abre la
     * solicitud con el visor de siempre, así no quedan dos modales apilados.
     */
    verSolicitud(item: HistorialDifItem): void {
        this.dialogRef.close({ solicitudId: item._id });
    }
}
